
import '../node_modules/regenerator-runtime/runtime.js';
import '@babel/polyfill';
import 'core-js/stable';


import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import { routeInterceptor, requestInterceptor, prototypeInterceptor } from './interceptors'
import 'virtual:uno.css'
import '@/style/index.scss'
import vant from 'vant';
// import wx from 'weixin-js-sdk';
// 2. 引入组件样式
import 'vant/lib/index.css';
// import '@babel/polyfill';
// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
// import "../src/utils/uniSdk"


// #ifndef MP-WEIXIN
window.wx = {}
// #endif

export function createApp() {
  const app = createSSRApp(App)
  app.use(vant);
  app.use(store)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  // app.provide('$wx', wx || {});
  app.use(prototypeInterceptor)
  return {
    app,
  }
}

